var map = {
	"./de-CH.json": 47634,
	"./de-DE.json": 36826,
	"./en-CA.json": 97581,
	"./en-GB.json": 20904,
	"./en-US.json": 45185,
	"./es-ES.json": 19416,
	"./fr-FR.json": 83896,
	"./it-IT.json": 65042,
	"./nl-NL.json": 97956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12557;